import { render, staticRenderFns } from "./GRNList.vue?vue&type=template&id=5b63d528&scoped=true&"
import script from "./GRNList.vue?vue&type=script&lang=js&"
export * from "./GRNList.vue?vue&type=script&lang=js&"
import style0 from "./GRNList.vue?vue&type=style&index=0&id=5b63d528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63d528",
  null
  
)

export default component.exports